@if (visible()) {
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div class="cd-backdrop" (click)="cancel()">
    <div
      class="cd-card"
      [class.cd-card--wide]="wide()"
      role="dialog"
      aria-modal="true"
      tabindex="-1"
      [attr.aria-label]="title()"
      (click)="$event.stopPropagation()"
      (keydown)="onCardKeydown($event)"
    >
      <div class="cd-header">
        <div class="cd-icon" aria-hidden="true">
          <mat-icon>{{ icon() }}</mat-icon>
        </div>
        <div class="cd-text">
          <div class="cd-title">{{ title() }}</div>
          <div class="cd-message">{{ message() }}</div>
        </div>
      </div>

      <div class="cd-body">
        <ng-content />
      </div>

      <div class="cd-actions">
        @if (showCancel()) {
          <button mat-stroked-button type="button" [disabled]="busy()" (click)="cancel()">
            {{ cancelLabel() }}
          </button>
        }
        <button
          mat-flat-button
          [color]="confirmColor()"
          class="cd-confirm"
          type="button"
          [disabled]="busy() || confirmDisabled()"
          (click)="confirmed.emit()"
        >
          @if (busy()) {
            <mat-progress-spinner diameter="16" mode="indeterminate" />
          }
          {{ confirmLabel() }}
        </button>
      </div>
    </div>
  </div>
}
